/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BackendConfiguration } from './BackendConfiguration';
import {
    BackendConfigurationFromJSON,
    BackendConfigurationFromJSONTyped,
    BackendConfigurationToJSON,
} from './BackendConfiguration';
import type { TenantModules } from './TenantModules';
import {
    TenantModulesFromJSON,
    TenantModulesFromJSONTyped,
    TenantModulesToJSON,
} from './TenantModules';

/**
 * 
 * @export
 * @interface Tenant
 */
export interface Tenant {
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    name: string;
    /**
     * 
     * @type {Array<BackendConfiguration>}
     * @memberof Tenant
     */
    configurations?: Array<BackendConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    company_website?: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    name_short?: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    default_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    ceo_name?: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    support_email?: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    dev_email?: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    app_subdomain?: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    portal_subdomain?: string;
    /**
     * 
     * @type {TenantModules}
     * @memberof Tenant
     */
    modules?: TenantModules;
}

/**
 * Check if a given object implements the Tenant interface.
 */
export function instanceOfTenant(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function TenantFromJSON(json: any): Tenant {
    return TenantFromJSONTyped(json, false);
}

export function TenantFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tenant {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'configurations': !exists(json, 'configurations') ? undefined : ((json['configurations'] as Array<any>).map(BackendConfigurationFromJSON)),
        'company_website': !exists(json, 'company_website') ? undefined : json['company_website'],
        'name_short': !exists(json, 'name_short') ? undefined : json['name_short'],
        'default_phone': !exists(json, 'default_phone') ? undefined : json['default_phone'],
        'ceo_name': !exists(json, 'ceo_name') ? undefined : json['ceo_name'],
        'support_email': !exists(json, 'support_email') ? undefined : json['support_email'],
        'dev_email': !exists(json, 'dev_email') ? undefined : json['dev_email'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'app_subdomain': !exists(json, 'app_subdomain') ? undefined : json['app_subdomain'],
        'portal_subdomain': !exists(json, 'portal_subdomain') ? undefined : json['portal_subdomain'],
        'modules': !exists(json, 'modules') ? undefined : TenantModulesFromJSON(json['modules']),
    };
}

export function TenantToJSON(value?: Tenant | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'configurations': value.configurations === undefined ? undefined : ((value.configurations as Array<any>).map(BackendConfigurationToJSON)),
        'company_website': value.company_website,
        'name_short': value.name_short,
        'default_phone': value.default_phone,
        'ceo_name': value.ceo_name,
        'support_email': value.support_email,
        'dev_email': value.dev_email,
        'domain': value.domain,
        'app_subdomain': value.app_subdomain,
        'portal_subdomain': value.portal_subdomain,
        'modules': TenantModulesToJSON(value.modules),
    };
}

